<script>
  export let data;
  export let even;
  export let year;
  export let width;
  export let slideIsActive;
  export let shouldRenderTitles;

  import { SwiperSlide } from "swiper/svelte";

  import Event from "./Event.svelte";
  import Year from "./Minor/Year.svelte";
  import Timeline from "./Minor/Timeline.svelte";
  import RandomStar from "./Minor/RandomStar.svelte";
  import Triangle from "./Shapes/Triangle.svelte";

  import { selectedType } from "../stores/global.js";

  $: hidden = function (type) {
    if ($selectedType) {
      return $selectedType != type;
    } else {
      return false;
    }
  };

  let anyActive = false;
  let active = null;
</script>

<SwiperSlide style="width: {width}px;" data-hash={year} class="slide-{year}">
  <RandomStar
    fill={slideIsActive ? "white" : "rgba(255, 255, 255, .1)"}
    isActive={slideIsActive}
    isOnSlide={true}
    needsExtraHeight={data.length > 3}
    {even}
  />
  <Triangle {year} {even} slideWidth={width} empty={data.length == 0} />
  <div
    class="slide {even ? 'even' : 'odd'} {data.length == 0
      ? 'empty'
      : data.length == 1
      ? 'single-event'
      : 'multiple-events'}
      {data.length > 3 ? 'need-extra-height' : ''}
      "
  >
    <Year {year} {even} />
    {#if data.length > 0}
      <Timeline {anyActive} {even} />
    {/if}
    <div
      class="events {even ? 'even' : 'odd'} 
      {data.length == 1 ? 'single-event' : 'multiple-events'}
      {anyActive ? 'any-active' : ''}"
    >
      {#each data as row, index}
        <div
          class="event-and-description-container event-{year}-{index}
          {hidden(row.type) ? 'hidden' : ''}"
        >
          <Event
            data={row}
            slideWidth={width}
            {slideIsActive}
            hidden={hidden(row.type)}
            eventIndex={index}
            maxIndex={data.length - 1}
            isReversedDueToLength={data.length >= 4}
            {shouldRenderTitles}
            bind:anyActive
            bind:active
          />
        </div>
      {/each}
    </div>
  </div>
</SwiperSlide>

<style>
  .slide {
    position: relative;
    z-index: 5;
    height: 100%;
    display: flex;
    overflow: visible;
  }

  :global(.swiper-slide-active .slide) {
    transform: translate3d(0, 0, 1px);
    -webkit-transform: translate3d(0, 0, 1px);
  }

  .events {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    z-index: 10;
  }

  .event-and-description-container {
    width: 100%;
    z-index: 20;
    overflow: visible;
  }

  .events {
    height: 43%;
    margin-top: 20px;
    margin-bottom: 25px;
    justify-content: space-between;
  }

  .events.odd {
    top: 0;
    position: absolute;
  }

  .events.even {
    bottom: 0;
    position: absolute;
  }

  @media screen and (min-width: 767px) {
    .events.even {
      margin-bottom: 35px;
    }
  }

  .events.single-event {
    justify-content: center;
  }

  .need-extra-height .events {
    height: 73%;
    flex-direction: column-reverse;
  }

  :global(.need-extra-height .events .event-and-description-container .event) {
    flex-direction: column-reverse;
  }

  /* MOBILE */
  @media screen and (max-width: 767px) {
    .events {
      height: 75%;
    }
  }
</style>
